import React from 'react';
import { AlertCircle } from 'lucide-react';
import { cn } from '../../lib/utils';

interface ErrorAlertProps extends React.HTMLAttributes<HTMLDivElement> {
  message?: string;
}

function ErrorAlert({
  message,
  className,
  ...containerProps
}: Readonly<ErrorAlertProps>): React.ReactElement {
  return (
    <div aria-live='polite' className={className} {...containerProps}>
      {message && (
        <div
          role='alert'
          className={cn(
            'flex items-center justify-center gap-2 rounded-[10px] bg-red-50',
            'px-4 py-3 text-center text-[13px] font-semibold text-red-600'
          )}
        >
          <AlertCircle className='h-4 w-4 shrink-0' aria-hidden />
          {message}
        </div>
      )}
    </div>
  );
}

export default ErrorAlert;
